export default "__VITE_ASSET__e53e13b2__"